module.exports = __webpack_public_path__ + "img/guiyuanlianzimizao.645b3003.jpg";